import { useParams } from 'react-router';

import { ProcessingScreenWithStore } from './ProcessingScreen';
import { UploadScreenWithStore } from './UploadScreen';

/**
 * BatchComic routes between UploadScreen and ProcessingScreen based on URL.
 * - /comic → UploadScreen (file upload and export settings)
 * - /comic/:id → ProcessingScreen (process status and results)
 */
export default function BatchComic() {
  const { id: processId } = useParams<{ id: string }>();

  if (processId) {
    // Let content define height so DefaultAppletLayout <main overflow-y-auto> can scroll.
    // Do not use lg:flex-1 / overflow-hidden here (upload needs those for internal panes).
    return (
      <div className="flex w-full flex-col">
        <ProcessingScreenWithStore />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col">
      <UploadScreenWithStore />
    </div>
  );
}
